import { t } from "@/i18n-js/instance";
import { ListingCard } from "./ListingCard";

interface AccessGroupListingCardProps {
  resources: Array<{ name: string; id: string; status: string }>;
}

export const AccessGroupListingCard = ({
  resources,
}: AccessGroupListingCardProps) => (
  <ListingCard
    title={t("help_widget.copilot.chat_card.access_groups")}
    resources={resources}
    emptyStateText={t("help_widget.copilot.chat_card.no_access_groups_found")}
    renderItem={access_group => `${access_group.name} (${access_group.status})`}
    getItemKey={access_group => access_group.id}
  />
);
